



































import { defineComponent, PropType, computed } from '@vue/composition-api';
import { SelectedListItem } from '../types';
const name = 'ttam-location-selected-box';
export default defineComponent({
  name,
  props: {
    list: {
      type: Array as PropType<SelectedListItem[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onTagDelete = tag => {
      emit('tag-delete', tag);
    };
    const onClickClearAll = () => {
      emit('clear-all');
    };
    return {
      name,
      onTagDelete,
      onClickClearAll,
    };
  },
});
